import { makeStyles } from '@material-ui/core';

export const useStyles = makeStyles({
  paragraph: {
    lineHeight: '1.5',
    fontSize: '1.2em',
  },
});
